import Vue from 'vue'
import config from '@/config';

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */
let handleOutsideClick

const GlobalDirectives = {
  install(Vue) { //v-role:show.admin
  console.log('INstalling directives')
  
    Vue.directive('role', function (el, bindings, vnode) {
        
      const item = bindings.value
      const roles = Object.keys(bindings.modifiers)
      const type = bindings.arg
      const hasRole = roles.indexOf(vnode.context.$settings.role) > -1 || (vnode.context.relation && roles.indexOf(vnode.context.relation._type) > -1)
      if ((!hasRole && type === 'show') 
          || hasRole && type === 'hide') {
          commentNode(el, vnode)
        } 
      if ((!hasRole && type === 'enable') 
          || hasRole && type === 'disable' ) {
          el.disabled = true
      }
    })
    
    Vue.directive('avatar', function (el, bindings, vnode) { //v-avatar:logo"
      var type = bindings.arg || 'avatar'
      var src = vnode.data.attrs.src
      if (!src || src.indexOf(':') > -1) return false
      if (!src || src.indexOf('.') == -1) {
        src = config[type].default
      } else if (src.indexOf(':') === -1) {
        src = config[type].location + src.replaceAll('/upload/','').replaceAll('/','__')  
      }
      console.log(src)
      if (el.src != src) el.src = src
    })
    
    Vue.directive('closable', {
      bind (el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
          e.stopPropagation()
          // Get the handler method name and the exclude array
          // from the object used in v-closable
          const { handler, exclude } = binding.value
    
          // This variable indicates if the clicked element is excluded
          let clickedOnExcludedEl = false
          exclude.forEach(refName => {
            // We only run this code if we haven't detected
            // any excluded element yet
            if (!clickedOnExcludedEl) {
              // Get the element using the reference name
              const excludedEl = vnode.context.$refs[refName]
              // See if this excluded element
              // is the same element the user just clicked on
              clickedOnExcludedEl = excludedEl.contains(e.target)
            }
          })
    
          // We check to see if the clicked element is not
          // the dialog element and not excluded
          if (!el.contains(e.target) && !clickedOnExcludedEl) {
            // If the clicked element is outside the dialog
            // and not the button, then call the outside-click handler
            // from the same component this directive is used in
            vnode.context[handler]()
          }
        }
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
      },
    
      unbind () {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
      }
    })
  }
};

Vue.use(GlobalDirectives)

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function commentNode(el, vnode) {
  const comment = document.createComment(' ')

  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined
  })

  vnode.text = ' '
  vnode.elm = comment
  vnode.isComment = true
  vnode.context = undefined
  vnode.tag = undefined
  vnode.data.directives = undefined

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el)
  }
}